module.exports = __webpack_public_path__ + "static/media/civil-status.b4de91af.png";